import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

interface MesoBrandResultListingProps {
  uci: string;
  className?: string;
  errorBoundaryLabel?: string;
}

export const MesoBrandResultListing: React.FunctionComponent<MesoBrandResultListingProps> = props => {
  const [adServed, setAdServed] = React.useState(false);

  const adRef = React.useRef(null);

  React.useEffect(() => {
    const node = adRef.current;

    if (node) {
      node.addEventListener('mesoAd', e => {
        if (e && e.detail) {
          if (e.detail.code === 'AD-LOAD-PASS') {
            setAdServed(true);
          }
          if (e.detail.code === 'AD-LOAD-EMPTY') {
            setAdServed(false);
          }
        }
      });
    }
  }, []);

  const { errorBoundaryLabel, uci, className } = props;

  return (
    <ErrorBoundary label={errorBoundaryLabel}>
      <li data-stid="meso-native" className={adServed ? className : ''}>
        <meso-native ref={adRef} uci={uci} nativetype="tile" isfluid={true} adslot={uci} data-testid="meso-native" />
      </li>
    </ErrorBoundary>
  );
};
MesoBrandResultListing.displayName = 'MesoBrandResultListing';

MesoBrandResultListing.defaultProps = {
  errorBoundaryLabel: 'hotel.meso',
};
